import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedItem: "",
  isEdit: false,
  itemData: [],
  serviceItems: [],
};

const invoiceNumberFormatSlice = createSlice({
  name: "invoiceNumberFormat",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = invoiceNumberFormatSlice.actions;

export default invoiceNumberFormatSlice.reducer;
